import { LocaleProvider, idiomaDoPainel } from "@/lib/i18n";
import { useMe } from "@/lib/queries";
import type { ReactNode } from "react";

/** Idioma e moeda para as telas que ficam FORA do Layout.
 *
 * São duas, e as duas por bom motivo: o assistente de configuração abre
 * antes de o painel fazer sentido, e a tela de assinatura precisa abrir
 * com a conta suspensa — que é exatamente quando o `/me/` do Layout
 * devolve 402 e o painel inteiro se recusa a montar.
 *
 * O efeito colateral era invisível: sem Provider, `useFormat()` caía no
 * default do contexto (moeda USD, idioma do navegador), e a oficina
 * brasileira via o preço dos serviços dela em dólar na primeira tela
 * depois do cadastro.
 *
 * `moeda` aceita um valor de fora porque a tela de assinatura conhece a
 * moeda pela própria cobrança mesmo quando o `/me/` não responde.
 */
export default function PainelLocale({
  moeda,
  children,
}: {
  moeda?: string;
  children: ReactNode;
}) {
  const { data: me } = useMe();
  return (
    <LocaleProvider
      idioma={idiomaDoPainel(me)}
      moeda={moeda ?? me?.garage.currency ?? me?.garage.region.currency ?? "BRL"}
    >
      {children}
    </LocaleProvider>
  );
}
